/**
 * **관리 웹 매장 검색 칸의 안내 한 곳** — 의존성이 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지).
 *
 * 서버(appserver `StoreSearchTerm`)가 검색어 한 칸으로 찾는 축 그대로다: 매장명·매장 번호·사업자번호(숫자 부분 일치)·휴대폰(사장님 휴대폰·매장
 * 전화). 매장 목록(`StoreListView` 검색 칸 이름)·요금·결제(구독·청구 검색 칸 — `subscriptionAdmin.js`)·매장 선택 창(+ 사업장명 —
 * `scopeTreeText.js`)이 이 값을 쓴다.
 *
 * `$t` 키로도 쓰인다 — 언어 자료는 문장 그대로 찾으므로 문장을 바꾸면 번역 행도 같이 본다.
 */
export const STORE_SEARCH_PLACEHOLDER = '매장명 · 매장 번호 · 사업자번호 · 휴대폰'
